// What can be done now leads; blocked actions trail, each group keeping its own order.
export function enabledFirst<T extends { disabled?: boolean }>(items: readonly T[]): T[] {
    return [...items.filter((i) => !i.disabled), ...items.filter((i) => i.disabled)];
}
